import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import InputField from '../../commonComponent/InputField'; // Assuming InputField is in the same directory
import { ToastContainer, toast } from 'react-toastify';
const AQ_BASE_URL = process.env.REACT_APP_AQ_BASE_URL;

const PasswordReset = () => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Access email and OTP passed from OtpVerification component
  const location = useLocation();
  const { email, otp } = location.state || {};

  const handleSubmit = async (e) => {
    e.preventDefault();
    const email = localStorage.getItem('email');

    // Check if email is missing from localStorage
    if (!email) {
      toast.error('Email is missing. Please check your email and try again.');
      return;
    }

    console.log('Email retrieved from localStorage:', email); // Debugging line
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);
    setError('');

    try {
      // Call API to reset password using fetch
      const response = await fetch(`${AQ_BASE_URL}/aq/api/resetPassword`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          email: email,
          new_password: newPassword,
          confirm_password: confirmPassword,
        }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        toast.success(data.message); // Display success message
        localStorage.clear();
        navigate('/login'); // Navigate to login page
      } else {
        setError(data.message || 'Failed to reset password. Please try again.');
      }
    } catch (err) {
      console.error('Error:', err);
      setError('Failed to reset password. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white shadow-lg rounded-lg p-8 max-w-md w-full">
        <h1 className="text-xl font-bold text-center">Reset Your Password</h1>
        <p className="text-xs text-slate-500 mb-5 text-center">
          Enter and confirm your new password below.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="flex flex-col gap-4">
            {/* New Password Field */}
            <InputField
              id="new-password"
              name="newPassword"
              type={showNewPassword ? 'text' : 'password'}
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              label="New Password"
              showPasswordToggle
              onToggleShowPassword={() => setShowNewPassword(!showNewPassword)}
            />

            {/* Confirm Password Field */}
            <InputField
              id="confirm-password"
              name="confirmPassword"
              type={showConfirmPassword ? 'text' : 'password'}
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              label="Confirm Password"
              showPasswordToggle
              onToggleShowPassword={() => setShowConfirmPassword(!showConfirmPassword)}
            />
          </div>

          {error && <p className="mt-2 text-sm text-red-600 font-medium">{error}</p>}

          <button
            type="submit"
            disabled={loading}
            className="w-full inline-flex justify-center mt-6 rounded-lg bg-green-700 px-3.5 py-2.5 text-sm font-medium text-white shadow-sm shadow-indigo-950/10 hover:bg-green-800"
          >
            {loading ? 'Resetting...' : 'Reset Password'}
          </button>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default PasswordReset;
